import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31614d03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root_frame" }
const _hoisted_2 = { class: "root_bg" }
const _hoisted_3 = { class: "card_bg" }
const _hoisted_4 = { class: "title_layout" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "introduction" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "desc" }

import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import TemplateRequest from '../../data/TemplateRequest';


export default /*#__PURE__*/_defineComponent({
  __name: 'Template-001',
  props: {
    view_key: {}
  },
  setup(__props: any) {

const props = __props;

const title = ref('');
const head_color = ref('');
const img_src = ref('');
const introduction = ref('');
const desc = ref<Array<string>>();
const { t } = useI18n();

onMounted(() => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var cardData: any = TemplateRequest.getViewDataByKey(props.view_key);
  title.value = cardData.title;
  console.log('title: ', title.value);
  head_color.value = cardData.head_color;
  img_src.value = cardData.img_src;
  console.log('img_src: ', img_src.value);
  introduction.value = cardData.introduction;
  desc.value = cardData.desc;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "header",
          style: _normalizeStyle({ background: head_color.value })
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(title.value), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(introduction.value), 1)
          ]),
          _createElementVNode("img", {
            class: "img",
            src: img_src.value
          }, null, 8, _hoisted_7)
        ], 4),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('template.featureIntro')), 1),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(desc.value, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "ul",
              key: item
            }, _toDisplayString(item), 1))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})